import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import {connect, useSelector} from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as React from 'react';
import {Component} from 'react';
import NotFound from '../pages/NotFound';
import UserInfo from '../auth/UserInfo';
import {Spin} from 'antd';
import Footer from './Footer';
import Header from './Header';
import RightBasketModal from '../pages/Consumer/basket/RightBasketModal';
import {reduxStore} from '../../services/redux/ReduxIndex';
import {elastic as Menu} from 'react-burger-menu';
import DropdownMenu from './DropdownMenu';
import {setGlobalSpinner, setMenuData} from '../../services/redux/actions/GeneralAction';
import i18n from '../../i18n';
import HelperGeneral from '../../helpers/HelperGeneral';

//General Pages
import Login from '../pages/Login';
import Register from '../pages/Register';
import Information from '../pages/Information';
import SalesPoints from '../pages/SalesPoints';
import Contact from '../pages/Contact';
import Lp from '../pages/Splash';
import ProductLandingPage from "../pages/ProductLandingPage";

//Pharmacy Pages
import HomePharmacy from '../pages/Pharmacy/Home';
import CategoryPharmacy from '../pages/Pharmacy/Category';
import ProductPharmacy from '../pages/Pharmacy/Product';
import CampaignPharmacy from '../pages/Pharmacy/Campaign';
import CampaignDetailPharmacy from '../pages/Pharmacy/CampaignDetail';
import MyAccountPharmacy from '../pages/Pharmacy/MyAccount';
import ArchivePharmacy from '../pages/Pharmacy/Archive';

//Consumer Pages
import HomeConsumer from '../pages/Consumer/Home';
import BasketViewConsumer from '../pages/Consumer/BasketView';
import CategoryConsumer from '../pages/Consumer/Category';
import ProductConsumer from '../pages/Consumer/Product';
import MyAccountConsumer from '../pages/Consumer/MyAccount';
import ArchiveConsumer from '../pages/Consumer/Archive';
import Api from "../../services/Api";
import {setBasketList} from "../../services/redux/actions/BasketAction";

function PrivateRoute({component: Component, ...rest}) {
    const selector = useSelector(state => state);
    const menuData = selector?.GeneralReducer?.menuData;
    const userInfo = UserInfo.info();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!UserInfo.isLogin()) {
                    return <Redirect to={{pathname: '/login', state: {from: props.location}}}/>;
                }
                if (!Component) {
                    return <Redirect to={{pathname: '/404', state: {from: props.location}}}/>;
                }
                return (
                    <>
                        <div className={'left-menu'}>
                            <Menu
                                isOpen={menuData?.leftMenuVisible}
                                left={true}
                                className={'left-menu'}
                                // root her zaman var (CRA index.html içinde). Wrapper element "not found" hatalarını engeller.
                                outerContainerId={'root'}
                                pageWrapId={'root'}
                                onClose={() => setMenuData({leftMenuVisible: false})}
                                width={320}
                            >
                                <DropdownMenu config={
                                    UserInfo.info('user_roles_id') === 3 ?
                                        menuData?.lists.filter(data => !data?.id.includes('archive')) :
                                        menuData?.lists.filter(data => (!data.id.includes('shiniq_world') && !data.id.includes('authorized_pharmacies')))
                                }
                                />
                            </Menu>
                        </div>
                        <div className={'main-container'}>
                            <Header/>
                            <Component {...props} />
                            {
                                navigator.userAgent !== 'inntheboxMobileSP' && (
                                    <Footer/>
                                )
                            }
                            {userInfo.user_roles_id === 3 && <RightBasketModal/>}
                        </div>
                    </>
                );
            }}
        />
    );
}

class Routers extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        const {location} = this.props;
        const user = UserInfo.info();

        //!INFO get'den gelen dil var ise başlayalım
        const url = new URL(window.location.href);
        const lang = url.searchParams.get('lang');
        if (lang) {
            await i18n.changeLanguage(lang);
        }

        if (!location?.pathname?.includes('/sepetim') && user?.user_roles_id === 3) {
            Api.getBasket().then((response) => {
                if (response?.data.products?.length > 0) {
                    localStorage.setItem("basketList", JSON.stringify(response.data));
                    setBasketList(response.data);
                } else {
                    localStorage.removeItem("basketList");
                    setBasketList([]);
                }
            }).catch((e) => {
                HelperGeneral.alert(e);
            });
        }

        if (
            location?.pathname !== '/anasayfa' &&
            !location?.pathname?.includes('/kategori') &&
            location?.pathname !== '/hesabim/bilgilerim'
        ) {
            UserInfo.globalCheck().then(() => {
                setTimeout(() => {
                    this.setState({
                        loading: false,
                    }, () => {
                        setGlobalSpinner(false);
                    });
                }, 300);
            }).catch(e => {
                if (e?.statusCode === 401) {
                    UserInfo.logout();
                } else {
                    HelperGeneral.alert(e);
                }
                setGlobalSpinner(false);
            });
        } else {
            this.setState({
                loading: false,
            }, () => {
                setGlobalSpinner(false);
            });
        }
    }

    componentDidUpdate(prevProps) {
        try {
            const prevPath = prevProps?.location?.pathname;
            const nextPath = this.props?.location?.pathname;
            if (prevPath !== nextPath && typeof window.soulTrackPageView === 'function') {
                window.soulTrackPageView();
            }
        } catch (e) {
            // best-effort
        }
    }

    render() {
        const {globalSpinner} = reduxStore.getState().GeneralReducer;
        const user = UserInfo.info();

        return (
            <Spin spinning={globalSpinner} delay={500} size={'large'} className={'root-spinner'}>
                <Switch>
                    <Redirect from={"/authorized-pharmacies"} to={"/yetkili-eczaneler"}/>
                    <Redirect from={"/archive"} to={"/arsiv"}/>
                    <Redirect from={"/login"} to={"/giris-yap"}/>
                    <Redirect from={"/register"} to={"/uye-ol"}/>
                    <Redirect from={'/category/:category_id'} to={'/kategori/:category_id'}/>
                    <Redirect from={'/product/:product_id'} to={'/urunler/:product_id'}/>
                    <Redirect from={"/home"} to={"/anasayfa"}/>
                    <Redirect from={"/faq"} to={"/sss"}/>
                    <Redirect from={"/contact"} to={"/iletisim"}/>
                    <Redirect from={"/campaign/:tab_key"} to={"/kampanyalar/:tab_key"}/>
                    <Redirect from={"/campaignDetail/:campaign_id"} to={"/kampanya-detayi/:campaign_id"}/>
                    <Redirect from={"/my-account/:tab_key"} to={"/hesabim/:tab_key"}/>
                    <Redirect from={"/hesabim/info"} to={"/hesabim/bilgilerim"}/>
                    <Redirect from={"/basket/view"} to={"/sepetim"}/>
                    <Redirect from={"/about"} to={"/hakkimizda"}/>
                    <Redirect from={"/kvkk"} to={"/kvkk-aydinlatma-metni"}/>
                    <Redirect from={"/explicit_consent_statement"} to={"/acik-riza-beyani"}/>

                    <Route exact path={'/'} component={!UserInfo.isLogin() ? Lp : Login}/>
                    <Route exact path={'/giris-yap'} component={Login}/>
                    <Route exact path={"/uye-ol"} component={Register}/>
                    <Route exact path={'/qr/:qrcode'} component={ProductLandingPage}/>

                    <PrivateRoute exact path={"/yetkili-eczaneler"} component={(user && user?.user_roles_id === 3) && SalesPoints}/>
                    <PrivateRoute exact path={"/iletisim"} component={Contact}/>
                    <PrivateRoute exact path={['/hakkimizda', '/kvkk-aydinlatma-metni', '/acik-riza-beyani', '/sss', '/ticari-elektronik-ileti']} component={Information}/>
                    <PrivateRoute exact path={'/anasayfa'} component={(user && user?.user_roles_id === 3) ? HomeConsumer : HomePharmacy}/>
                    <PrivateRoute exact path={'/kategori/:category_id'} component={(user && user?.user_roles_id === 3) ? CategoryConsumer : CategoryPharmacy}/>
                    <PrivateRoute exact path={'/kategori/:category_id/:sub_id'} component={(user && user?.user_roles_id === 3) ? CategoryConsumer : CategoryPharmacy}/>
                    <PrivateRoute exact path={'/urunler/:product_id'} component={(user && user?.user_roles_id === 3) ? ProductConsumer : ProductPharmacy}/>
                    <PrivateRoute exact path={"/dokumanlar"} component={(user && user?.user_roles_id === 3) ? ArchiveConsumer : ArchivePharmacy}/>
                    <PrivateRoute exact path={"/dokumanlar/:documentType"} component={(user && user?.user_roles_id === 3) ? ArchiveConsumer : ArchivePharmacy}/>
                    <PrivateRoute exact path={'/hesabim/:tab_key'} component={(user && user?.user_roles_id === 3) ? MyAccountConsumer : MyAccountPharmacy}/>
                    <PrivateRoute exact path={['/sepetim', '/center/payment/:order_id', '/center/payment/:order_id/error']} component={(user && user?.user_roles_id === 3) && BasketViewConsumer}/>
                    <PrivateRoute exact path={['/sepetim', '/center/payment/:order_id', '/center/payment/:order_id/error']} component={(user && user?.user_roles_id === 3) && BasketViewConsumer}/>
                    <PrivateRoute exact path={'/kampanyalar/:tab_key'} component={(user && user?.user_roles_id !== 3) && CampaignPharmacy}/>
                    <PrivateRoute exact path={['/kampanya-detayi/:campaign_id']} component={(user && user?.user_roles_id !== 3) && CampaignDetailPharmacy}/>

                    <Route path={'/404'} component={NotFound}/>
                    <Redirect to={"/404"}/>
                </Switch>
            </Spin>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    userInfo: state.UserReducer.userInfo,
    globalSpinner: state.GeneralReducer.globalSpinner,
    menuData: state.GeneralReducer.menuData,
});

export default withTranslation(['search'])(withRouter(connect(mapStateToProps)(Routers)));
